module.exports = __webpack_public_path__ + "img/img2.c8ccf1e0.png";